import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompanyContext } from '../../../../../../../context/CompanyContext';
import { TaskExportConfigurationContext } from '../../../../../../../context/TaskExportConfigurationContext';
import {
  TaskExportConfiguration,
  TaskExportField,
} from '../../../../../../../types/task_export_configuration/taskExportConfiguration';
import TaskExportConfigurationForm, { DraggableTaskExportFieldIdentifier } from '../Common/TaskExportConfigurationForm';
import { BackButton, ButtonVariant, CreateButton } from '../../../../../../components/Button';
import { Routing } from '../../../../../../../util/routes.util';
import { useRequest } from '../../../../../../../requests/common/requestHook';
import { TaskExportConfigurationRequest } from '../../../../../../../requests/taskExportConfiguration.request';
import { DraggableItemData } from '../../../../../Common/DraggableItem';
import { TaskExportConfigurationInput } from '../../../../../../../types/task_export_configuration';

interface CreateTaskExportConfigurationPaneProps {}

export default function CreateTaskExportConfigurationPane({}: CreateTaskExportConfigurationPaneProps) {
  const navigate = useNavigate();
  const { currentCompany } = useContext(CompanyContext);
  const { taskExportConfigurations, setTaskExportConfigurations, taskExportConfigurationsLoading } =
    useContext(TaskExportConfigurationContext);

  const [input, setInput] = useState<TaskExportConfigurationInput>(
    new TaskExportConfigurationInput(TaskExportConfiguration.default(currentCompany.id)),
  );

  const [create, { loading }] = useRequest(TaskExportConfigurationRequest.create);

  const handleCreate = async (
    configuration: TaskExportConfigurationInput,
    items: DraggableTaskExportFieldIdentifier[],
  ) => {
    configuration.mapping = DraggableItemData.toMap<TaskExportField>(items);

    const result = await create({ data: [configuration.forCreate()] });
    if (!result) return;

    const config = result[0];
    taskExportConfigurations.set(config.id, new TaskExportConfiguration(config));
    setTaskExportConfigurations(new Map(taskExportConfigurations));
    navigate(Routing.tasks.settings.report.overview());
  };

  const footer = (configuration: TaskExportConfigurationInput, items: DraggableTaskExportFieldIdentifier[]) => {
    return (
      <div className='flex justify-end'>
        <div className='flex items-center gap-2'>
          <BackButton
            disabled={loading}
            variant={ButtonVariant.secondary}
            onClick={() => navigate(Routing.tasks.settings.report.overview())}
          />
          <CreateButton
            loading={loading}
            onClick={() => handleCreate(configuration, items)}
            disabled={!configuration.filename || !configuration.name}
          />
        </div>
      </div>
    );
  };

  return (
    <TaskExportConfigurationForm
      input={input}
      setInput={setInput}
      footer={footer}
      loading={taskExportConfigurationsLoading}
    />
  );
}
